<div class="popup">
  <div class="popup__header">
    <h3 class="popup__title">
      {{ (isEditMode ? 'messageCenter.editGroup' : 'messageCenter.newGroupChat') | translate }}
    </h3>

    <button
      mat-icon-button
      class="close-icon"
      (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div matDialogContent>
    <div class="popup__content">
      @if (isLoading()) {
        <app-dialog-skeleton />
      } @else {
        <form novalidate autocomplete="off" [formGroup]="form">
          <!-- Avatar upload -->
          <input #avatarInput hidden type="file" accept="image/*" (change)="onAvatarFileChange($event)" />

          <div class="avatar-section">
            <div class="avatar-upload">
              @if (hasAvatar) {
                <div class="avatar-upload__circle avatar-upload__circle--img">
                  <img class="avatar-upload__img" [src]="avatar.value" alt="Group avatar" />
                  <button
                    type="button"
                    class="avatar-upload__camera"
                    (click)="openAvatarUpload()">
                    <mat-icon class="material-icons-outlined">photo_camera</mat-icon>
                  </button>

                  <button
                    type="button"
                    class="avatar-upload__remove"
                    (click)="clearAvatar()">
                    <mat-icon class="material-icons-outlined">close</mat-icon>
                  </button>
                </div>
              } @else {
                <div class="avatar-upload__circle" (click)="openAvatarUpload()">
                  @if (showMemberGrid()) {
                    <app-user-avatar
                      radius="30px"
                      [size]="96"
                      [nestedAvatarSize]="38"
                      [avatars]="membersForAvatarGrid()">
                    </app-user-avatar>
                  } @else {
                    <div class="avatar-upload__placeholder">
                      <mat-icon class="material-icons-outlined avatar-upload__placeholder-icon">groups</mat-icon>
                    </div>
                  }
                  <button
                    type="button"
                    class="avatar-upload__camera"
                    (click)="openAvatarUpload(); $event.stopPropagation()">
                    <mat-icon class="material-icons-outlined">photo_camera</mat-icon>
                  </button>
                </div>
              }
            </div>
            <p class="avatar-section__hint">{{ avatarHint | translate }}</p>
          </div>

          <!-- Form fields -->
          <div class="form-fields">
            <div class="form-group">
              <label class="form-label">{{ 'messageCenter.groupName' | translate }}</label>
              <input
                class="form-control"
                type="text"
                appTrimInput
                formControlName="name"
                [placeholder]="'messageCenter.enterGroupName' | translate" />
            </div>

            <div class="form-group">
              <label class="form-label">{{ 'messageCenter.groupType' | translate }} *</label>
              <div class="type-toggle">
                <button
                  type="button"
                  class="type-toggle__btn"
                  [class.active]="isPublicType"
                  (click)="groupTypeChanged(GroupType.Public)">
                  <mat-icon class="material-icons-outlined">public</mat-icon>
                  {{ 'common.public' | translate }}
                </button>

                <button
                  type="button"
                  class="type-toggle__btn"
                  [class.active]="isPrivateType"
                  (click)="groupTypeChanged(GroupType.Private)">
                  <mat-icon class="material-icons-outlined">lock</mat-icon>
                  {{ 'common.private' | translate }}
                </button>
              </div>

              @if (isPublicType) {
                <p class="form-hint">{{ 'messageCenter.anyoneCanJoin' | translate }}</p>
              }
            </div>

            @if (isPrivateType) {
              <div class="form-group">
                <label class="form-label">{{ 'messageCenter.addParticipants' | translate }} *</label>
                <div class="participants-input">
                  <app-select-chip-input
                    ngDefaultControl
                    [allChips]="allChipsUsers()"
                    [selectedChips]="selectedChipsUsers()"
                    (selectedChip)="addChipsUser($event)"
                    (valueChanged)="loadUsers($event)"
                    (removedChip)="removeChip($event)"
                    (blurEmitter)="loadUsers()">
                  </app-select-chip-input>
                </div>
              </div>
            }
          </div>
        </form>
      }
    </div>
  </div>

  <div class="popup__buttons">
    <button
      matRipple
      class="app-button"
      (click)="close()">
      {{ 'buttons.cancel' | translate }}
    </button>

    <button
      matRipple
      class="mc-button mc-button_blue btn-submit"
      [disabled]="isInvalid()"
      (click)="createGroup()">
      @if (isSending()) {
        <app-loading size="extra_small"></app-loading>
      } @else {
        <mat-icon class="material-icons-two-tone btn-icon">group_add</mat-icon>
      }
      {{ (isEditMode ? 'messageCenter.editGroup' : 'messageCenter.createGroup') | translate }}
    </button>
  </div>
</div>
